import { render } from "./ChevronRight.vue?vue&type=template&id=2bcb1250"
import script from "./ChevronRight.vue?vue&type=script&lang=js"
export * from "./ChevronRight.vue?vue&type=script&lang=js"
script.render = render

export default script